import { useCallback, useEffect, useState } from 'react';

/**
 * This hook detects if the page has been scrolled.
 * Similar to `useHasUserScrolled`, but this one triggers on any scroll event (user-initiated or programmatic).
 */
export const useHasScrolled = (): boolean => {
  const [hasScrolled, setHasScrolled] = useState(false);

  const handleScroll = useCallback(() => {
    if (window.scrollY === 0) {
      return;
    }

    setHasScrolled(true);
    window.removeEventListener('scroll', handleScroll);
  }, [setHasScrolled]);

  useEffect(() => {
    if (hasScrolled) {
      return;
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasScrolled, handleScroll]);

  return hasScrolled;
};
